import React, {useEffect} from 'react';
import './Deco/Deco.css';
import Background from './Deco/forest-morning-fall.jpg';
import homeBackground from './Deco/forest-morning-fall-feb-17.jpg';

const PrivacyAdFree = () => {
    //const style = { background: `url(${Background})`, backgroundRepeat: "no-repeat", backgroundPosition: "center", backgroundAttachment: "fixed", backgroundSize: "cover", border: "2px solid orange", height: "100%", margin: "0", padding: "0" };

    useEffect(() => {
        const html = document.querySelector('html');

        html.style.backgroundImage = `url(${Background})`;
        html.style.backgroundRepeat = 'no-repeat';
        html.style.backgroundPosition = 'center';
        html.style.backgroundAttachment = 'fixed';
        html.style.backgroundSize = 'cover';

        return () => {
        html.style.backgroundImage = `url(${homeBackground})`;
        html.style.backgroundRepeat = 'no-repeat';
        html.style.backgroundPosition = 'center';
        html.style.backgroundAttachment = 'fixed';
        html.style.backgroundSize = 'cover';

        };

    }, []);

    return (
        <div>
            <h1>Fog Over Hills - Ad Free</h1>

            <div>
                <div className="PSCard">

                    <pics>
                        <p><b>Privacy Policy for Fog Over Hills - Ad Free</b></p>
                        <p>Effective Date: 05/21/2026</p>
                        <p>This app does not collect, store, or share any personal information.</p>

                        <p>The game:</p>

                        <p>works completely offline</p>
                        <p>does not require account creation</p>
                        <p>does not use analytics</p>
                        <p>does not display advertisements</p>
                        <p>does not transmit user data to external servers</p>
                        <p><b>Contact Us:</b></p>
                        <p>If you have any questions or concerns about this Privacy Policy or our app's privacy practices, please contact us at Paradisesettler@gmail.com.</p>
                    </pics>
                </div>
            </div>

        </div>
    )
}

export default PrivacyAdFree;